<script>
import { Label } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'

export default {
  mixins: [ListMixin],
  data() {
    return {
      editRouteName: 'Edit Label',
      addRoute: { name: 'Add Label' },
      verboseName: 'Etykieta',
      verboseNamePlural: 'Etykiety',
      listFields: [
        { prop: 'id', label: 'id', width: 80 },
        { prop: 'name', label: 'Nazwa' }
      ]
    }
  },
  computed: {
    service() {
      return Label
    }
  }
}
</script>
